import React from 'react';
import AppRoutes from './routes/app-routes';
import './app.css';

const App: React.FC = () => {
  return (
    <>
      <AppRoutes />
    </>
  );
};

export default App;
